// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import Vant from 'vant';
import { Icon } from 'vant'
import '@/styles/iconfont.css'
import 'vant/lib/index.css';
// import './assets/iconfont/iconfont.css'
import { Select, Option, Input, Button, Timeline, TimelineItem, Link } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as filters from "./filters";
// import "./styles/var.scss"
import axios from 'axios'


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.config.productionTip = false
Vue.use(Vant);
Vue.use(Icon)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Button)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Link)
/* eslint-disable no-new */
Vue.prototype.$axios = axios
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App,

  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js